<template>
    <div>
        <form-row title="List Price" :no_border="true" class="my-6">
            <div class="sm:w-40">
                <input-money
                    name="list_price"
                    :value="listing_detail.list_price"
                    :read_only="read_only"
                />
            </div>
        </form-row>

        <div class="border-b border-gray-400 sm:ml-46 mb-6"></div>
    </div>
</template>

<script>
export default {
    props: {
        listing_detail: { default: () => ({}) },
        read_only: { default: false },
    },
}
</script>
